export default {"src":"/_next/static/media/fancy.7bc6dd8e.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};